import * as Sauce from "Sauce";
import * as React from "react";
import { Link } from "react-router";
export class Nav extends Sauce.Component<{}, {}> {
    render() {
        return <div className="container">
            <ul>
                <Link to="/"><li>Home</li></Link>
                <Link to="/markov" activeStyle={{ fontWeight: "bold" }}><li>Markov</li></Link>
                <Link to="/parametric" activeStyle={{ fontWeight: "bold" }}><li>Parametric</li></Link>
                <Link to="/matrixtest" activeStyle={{ fontWeight: "bold" }}><li>Matrix</li></Link>

            </ul>
            {this.props.children}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/code/Nav.tsx